module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("LIST OF ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. THE GOD MARDUK (from F. H. Weissbach, "), _c('i', [_vm._v("Babylonische Miscellen")]), _vm._v(" [Leipzig, 1903], p. 16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. A SYMBOLICAL REPRESENTATION OF THE GOD ASHUR (from a cast in the Oriental Institute of the University of Chicago)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. KING ASHURBANIPAL POURING OUT A LIBATION OVER FOUR DEAD LIONS (courtesy of the British Museum)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. A BABYLONIAN BOUNDARY STONE (courtesy of the British Museum)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A BABYLONIAN DRAGON (from R. Koldewey, "), _c('i', [_vm._v("Das wieder erstehende Babylon")]), _vm._v(" [Leipzig, 1925], Fig. 31)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. FIGHT BETWEEN A GOD AND A MONSTER (photograph; from E. A. Wallis Budge, "), _c('i', [_vm._v("Assyrian Sculptures in the British Museum, Reign of Ashur-nasir-pal, 885–860 B.C")]), _vm._v(". [London, 1914], Pl. XXXVII)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. FIGHT BETWEEN A GOD AND A MONSTER (drawing; courtesy of the British Museum)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. A SEAL IMPRESSION DEPICTING A FIGHT BETWEEN A GOD AND A DRAGON (courtesy of the British Museum)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. PART OF THE FOURTH TABLET OF “ENÛMA ELISH” (courtesy of the British Museum)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. THE SUN-GOD APPEARING ON THE MOUNTAINOUS EASTERN HORIZON (courtesy of the British Museum)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. RESTORATION OF THE BABYLON OF NEBUCHADREZZAR AS SEEN FROM THE WESTERN BANK OF THE EUPHRATES (from a painting in the Oriental Institute)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. RESTORATION OF THE BABYLON OF NEBUCHADREZZAR AS SEEN FROM THE NORTH END OF THE PROCESSION STREET (from E. Unger, "), _c('i', [_vm._v("Babylon, die heilige Stadt")]), _vm._v(" [Berlin and Leipzig, 1931], Frontispiece)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. A WINGED HUMAN-HEADED BULL FROM THE PALACE OF SARGON OF ASSYRIA (courtesy of the Oriental Institute)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. THE TABLET CONTAINING THE BILINGUAL VERSION OF THE CREATION OF THE WORLD BY MARDUK (courtesy of the British Museum)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. A SEVEN-HEADED SERPENT ON A SUMERIAN MACE HEAD (from "), _c('i', [_vm._v("Analecta orientalia")]), _vm._v(", No. 12 [1935], p. 108)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. THE SLAYING OF A SEVEN-HEADED DRAGON (courtesy of the Oriental Institute)")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_14_fig#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. A CYLINDER SEAL FORMERLY SUPPOSED TO REPRESENT THE BABYLONIAN TRADITION OF THE FALL OF MAN (courtesy of the British Museum)")]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d9f8ffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226112428_08_illu.vue
// module id = 72
// module chunks = 0